import createSafeContext from '@paradigm/utils/createSafeContext';

export const [useRowIndex, RowIndexProvider] =
  createSafeContext<number>('RowIndex');
